import { Component, OnInit, ViewChild } from '@angular/core';
import { ListTableComponent } from '../../../../shared/components/list-table/list-table.component';
import { BillingFilterComponent } from '../../billing-filter/billing-filter.component';
import { ListService } from '../../../../shared/services/list.service';
import { BillingService } from '../../../../services/billing.service';
import { DatePipe } from '@angular/common';
import { SharedDataService } from '../../../../shared/services/shared-data-service';
import {
  STATIC_DATA,
  STATIC_JSON_DATA_PATH,
} from '../../../../shared/constants/static-data.constants';
import { PAGE_CONSTANTS } from '../../../../shared/constants/page.constants';
import { ActivatedRoute } from '@angular/router';
import { LoggerService } from '../../../../shared/services/logger.service';
import { SectionsService } from '../../../../services/sections.service';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'ppl-cdr-list',
  standalone: true,
  imports: [ListTableComponent, BillingFilterComponent],
  templateUrl: './ignored-timesheets-list.component.html',
  styleUrl: './ignored-timesheets-list.component.css',
})
export class IgnoredTimesheetsListComponent implements OnInit {
  sharedDataKey: string = STATIC_DATA.SHARED_CDR_RECON_DATA;
  pageId: string = PAGE_CONSTANTS.CDR_RECON_GRID_PAGE;
  programName!: string;
  appliedFilters: any;
  ignoredTimesheetData: any[] = [];

  @ViewChild(ListTableComponent) childComponent!: ListTableComponent;

  fields: any[] = [
    { field: 'timesheetId', show: true },
    { field: 'participantPplId', show: true },
    { field: 'providerPplId', show: true },
    { field: 'mcoName', show: true },
    { field: 'ignoreReason', show: true },
  ];
  cols = [];

  constructor(
    private listService: ListService,
    private billingService: BillingService,
    private datePipe: DatePipe,
    private sharedDataService: SharedDataService,
    private route: ActivatedRoute,
    private logger: LoggerService,
    private sectionService: SectionsService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.getColumnData();
    const navigationState = window.history.state;
    if (navigationState.reason || navigationState.mco) {
      this.fields = [
        { field: 'timesheetId', show: true },
        { field: 'participantPplId', show: true },
        { field: 'providerPplId', show: true },
        {
          field: 'mcoName',
          show: true,
          default:
            navigationState.mco && navigationState.mco !== 'All'
              ? navigationState.mco
              : null,
        },
        {
          field: 'ignoreReason',
          show: true,
          default:
            navigationState.reason && navigationState.reason !== 'All'
              ? navigationState.reason
              : null,
        },
      ];

      const filters = [];

      if (navigationState.mco && navigationState.mco !== 'All') {
        filters.push({
          jsonPath: 'mcoName',
          value: navigationState.mco,
          operator: 'Equal',
        });
      }
      if (navigationState.reason && navigationState.reason !== 'All') {
        filters.push({
          jsonPath: 'ignoreReason',
          value: navigationState.reason,
          operator: 'Equal',
        });
      }
      this.searchignoredTimesheets(filters);
    } else {
      const filters: any[] = [];
      this.searchignoredTimesheets(filters);
    }
  }

  async getColumnData() {
    try {
      const tempCols = await this.sectionService.getJsonConfigurationData(
        STATIC_JSON_DATA_PATH.IGNORED_TS_LIST_PAGE_HEADERS,
        'billing'
      );
      this.cols = tempCols.columns;
    } catch (e) {
      this.logger.debug('Error in getting column data', e);
    }
  }

  onSearch(filters: any) {
    this.appliedFilters = filters;
    this.searchignoredTimesheets(filters);
  }

  buildRequestPayload(
    pageName: string,
    orderBy: string,
    searchParams: [],
    startingPageNumber = 1
  ) {
    const payload: any = {
      pageName: pageName,
      programCode: this.programName,
      condition: 'and',
      recordsPerPage: 20,
      startingPageNumber: startingPageNumber,
      searchParam: searchParams,
      orderByColumn: orderBy ? [orderBy] : [],
      orderBy: ['desc'],
    };
    return payload;
  }
  searchignoredTimesheets(
    filters: any,
    startingPageNumber = 1,
    currentPage = 0
  ) {
    if (startingPageNumber == 1) {
      this.ignoredTimesheetData = [];
    }
    const processedPayload = this.buildRequestPayload(
      'ignoreTimeSheetView',
      'timesheetId',
      filters,
      startingPageNumber
    );
    this.listService
      .getListData(processedPayload, 'billing')
      .subscribe((data: any) => {
        const records = data.responsedata;
        if (startingPageNumber > 1) {
          this.ignoredTimesheetData = [
            ...this.ignoredTimesheetData,
            ...records,
          ];
          this.childComponent.resetPagination(startingPageNumber, currentPage);
        } else {
          this.ignoredTimesheetData = records;
        }
      });
  }

  rowClicked(event: any) {
  }

  onAction(event: any) {
  }

  onPageLoad(event: any) {
    this.searchignoredTimesheets(
      this.appliedFilters,
      event.startingPageNumber,
      event?.first ?? 0
    );
  }
  rowActions(event: any) {
  }

  clearData() {
    this.sharedDataService.clearData(this.sharedDataKey);
  }
}
